import { toDigits } from '@imprint-payments/imprint-lib/dist/utilities/toDigits';

import { ApiRequestV2, httpRequestV2 } from '../http/client';
import { Method } from '../http/httpConsts';

export interface LoginRequest {
  phone: string;
  // resend: boolean; TODO: add this? not present before refactor
}

export interface LoginResponse {
  requestID: string;
  nextStep: LoginNextStep;
  consumerUUID: string;
}

export type LoginNextStep =
  | 'verifyOTP'
  | 'showSignUp'
  | 'verifyPIN'
  | 'verifyPII'
  | 'verifyDOB'
  | 'setPIN';

export interface LoginError {
  code: string;
  message: string;
}

export const login = async ({
  phone,
}: LoginRequest): Promise<LoginResponse> => {
  const req: ApiRequestV2 = {
    path: '/v1/consumer/login',
    method: Method.POST,
    body: {
      phone: toDigits(phone),
    },
  };

  return httpRequestV2(req);
};
